import React, { useState } from 'react';
import '../Styles/IndividualRegistrationReview.scss';
import { FamilyCampPageOptions } from '../Constants/RegistrationPageOptions';
import { RoomTier, getRosterLines, getRegistrationFeeDue, getCampFeeDue, getTotal } from '../Constants/FamilyCampConfig';
import DateHelpers from '../Helper/DateHelpers';

function FamilyCampRegistrationReview({ week, roomType, personalInformation, setSelectedPage, AddToCart }) {

   const [addToCartError, setAddToCartError] = useState('')
   const [addingToCart, setAddingToCart] = useState(false)

   const roster = getRosterLines(week, roomType, personalInformation);
   const registrationFeeDue = getRegistrationFeeDue(week, personalInformation);
   const campFeeDue = getCampFeeDue(week, roomType, personalInformation);
   const total = getTotal(week, roomType, personalInformation);

   function handlePrevious() {
      setSelectedPage(FamilyCampPageOptions.Disclaimer);
   }

   async function handleNext() {
      setAddingToCart(true)
      setAddToCartError('')
      const message = await AddToCart()
      if (message) {
         setAddToCartError(message)
         setAddingToCart(false)
      }
   }

   return (
      <div className="IndividualRegistrationReviewContent">
         <div className="IndividualRegistrationReviewHeading">
            Review Registration Information
         </div>
         <div className="IndividualRegistrationReviewBody">
            _______________________________
            <div className="IndividualRegistrationReviewEventInformation">
               <div className="IndividualRegistrationReviewEventInformationHeading">
                  Event Information
               </div>
               <div className="IndividualRegistrationReviewEventInformationContent">
                  <div className="IndividualRegistrationReviewCampName">
                     Family Camp Selected: {week.camp_name}
                  </div>
                  <div className="IndividualRegistrationReviewStartDate">
                     Dates: {DateHelpers.getEventDateRange(week.begin_date, week.end_date)}
                  </div>
                  <div className="IndividualRegistrationReviewRoomType">
                     Room Type: {roomType === RoomTier.Deluxe ? 'Deluxe' : 'Standard'}
                  </div>
               </div>
            </div>
            _______________________________
            <div className="IndividualRegistrationReviewEventInformation">
               <div className="IndividualRegistrationReviewEventInformationHeading">
                  Family Members
               </div>
               <div className="IndividualRegistrationReviewEventInformationContent">
                  {roster.map((line) => (
                     <div className="IndividualRegistrationReviewSons" key={line.position}>
                        {line.firstName} {line.lastName}
                        {line.position === 1 && ' (Registrant)'}
                        :&nbsp;&nbsp;${line.price.toFixed(2)}
                     </div>
                  ))}
               </div>
            </div>
            _______________________________
            <div className="IndividualRegistrationReviewCostBreakdown">
               <div className="IndividualRegistrationReviewCostBreakdownHeading">
                  Cost Breakdown
               </div>
               <div className="IndividualRegistrationReviewCostBreakdownContent">
                  <div className="IndividualRegistrationReviewRegistrationFee">
                     Registration Fee{roster.length > 1 && ` (${roster.length} × $${Number(week.registration_fee).toFixed(2)})`}:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${registrationFeeDue.toFixed(2)}
                  </div>
                  <div className="IndividualRegistrationReviewCampFee">
                     Camp Fee:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${campFeeDue.toFixed(2)}
                  </div>
                  <div className="IndividualRegistrationReviewTotalAmountDue">
                     Total Amount Due:&nbsp;${total.toFixed(2)}
                  </div>
               </div>
            </div>
            _______________________________
         </div>
         {addToCartError &&
            <div className="IndividualRegistrationReviewError">
               {addToCartError}
            </div>
         }
         <div className="IndividualRegistrationReviewButtons">
            <div className="IndividualRegistrationReviewPreviousButton">
               <button onClick={handlePrevious} disabled={addingToCart}>
                  Previous
               </button>
            </div>
            <div className="IndividualRegistrationReviewNextButton">
               <button onClick={handleNext} disabled={addingToCart}>
                  {addingToCart ? 'Adding…' : 'Add to Cart'}
               </button>
            </div>
         </div>
      </div>
   )
}

export default FamilyCampRegistrationReview;
